import { useEffect, useState } from "react";
import { Layout } from "./components/Layout";
import { AddOrder } from "./pages/AddOrder";
import { Dashboard } from "./pages/Dashboard";
import { Orders } from "./pages/Orders";
import { ProductRules } from "./pages/ProductRules";
import { ReviewOcr } from "./pages/ReviewOcr";
import { UploadScreenshot } from "./pages/UploadScreenshot";

function getRoute() {
  const hash = window.location.hash.replace(/^#/, "");
  return hash || "/";
}

export function App() {
  const [route, setRoute] = useState(getRoute);

  useEffect(() => {
    const onHashChange = () => setRoute(getRoute());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <Layout route={route}>
      {route === "/" ? <Dashboard /> : null}
      {route === "/orders" ? <Orders /> : null}
      {route === "/add" ? <AddOrder /> : null}
      {route === "/upload" ? <UploadScreenshot /> : null}
      {route === "/review" ? <ReviewOcr /> : null}
      {route === "/rules" ? <ProductRules /> : null}
      {!["/", "/orders", "/add", "/upload", "/review", "/rules"].includes(route) ? (
        <Dashboard />
      ) : null}
    </Layout>
  );
}
